/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */
import { decodeScriptTag } from '@/helpers/utils'

export default {
  getContentPage: state => decodeScriptTag(state.content),
  getMetaPage: state => state.meta,
  getContent: (state) => (contentID) => {
    return state.contents[contentID] ? decodeScriptTag(state.contents[contentID].content) : ''
  },
  getContents: state => state.contents,
  getCategories: state => state.lastCall.filters,
  getOrderable: state => state.lastCall.orderable,
  hasHeaderBanner (state) {
    let currentState = !!state.contents['header-banner']
    if (process.client && currentState && global.$cookies.get('hide-top-banner-badge') === 'true') {
      currentState = false
    }
    return currentState
  },
  getCurrentPost: state => state.blogPost
}
